// Card production — physical cards are pass-through and depend on material,
// batch size, and design. Current Wirex sheet states a 3,000-unit MOQ.
// Distinct from Tier.physicalCardCost (what the user pays). This is COGS.
//
// Adoption — share of new users in each tier who actually receive a physical card.

/**
 * Card production cost for new users this month.
 *
 * @param {object} inputs
 * @param {object} newByTier  { free, pro } — new users this month per tier
 * @returns {number} EUR cost to Pulsar this month for card production
 */
export function cardProductionCost(inputs, newByTier) {
  const cfg = inputs.cardProduction;
  if (!cfg) return 0;

  let total = 0;
  for (const k of Object.keys(newByTier)) {
    const cost = cfg.costPerNewCard?.[k] ?? 0;
    const adoption = cfg.physicalAdoption?.[k] ?? 0;
    total += newByTier[k] * cost * adoption;
  }
  return total;
}
